/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS, ArcElement, Tooltip, Legend, LegendItem,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);
export interface StaticData {
  labels: string[];
  datasets: {
    data: string[];
    backgroundColor: string[];
    hoverBackgroundColor: string[];
    borderWidth: number;
  }[];
}

export interface DonutChartProps {
  staticData: StaticData,
  drilldownData: StaticData[]
}

export default function DonutChart({ staticData, drilldownData }: DonutChartProps) {
  const [chartData, setChartData] = useState(staticData);
  const [activityFlag, setFlag] = useState(false);

  useEffect(() => {
    setChartData(staticData);
  }, [staticData]);

  const handleClick = (_: any, chartElements: any) => {
    if (chartElements.length === 0) {
      setChartData(staticData);
      setFlag(false);
      return;
    }
    const segmentIndex: number = chartElements[0].index;
    const drilldownSegment: StaticData = drilldownData[segmentIndex];
    setChartData(drilldownSegment);
    setFlag(true);
  };

  return (
    <div className="flex items-center justify-center w-[17vw]">
      <Doughnut
        data={chartData}
        options={{
          onClick: handleClick,
          plugins: {
            legend: {
              onClick: (e, legendItem: LegendItem) => {
                // This will prevent the default click action
              },
              display: !!activityFlag,
              position: 'top',
              rtl: false,
              labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                padding: 20,
              },
            },
          },
          cutout: '26%',
        }}
      />
    </div>
  );
}
